import { graphql } from '~/gql'

export const GET_FACILITY_CLIMATE_SETTINGS_QUERY = graphql(`
  query GetFacilityClimateSettings($id: ID!) {
    facility: Facility(id: $id) {
      id
      units
      primaryUse
      primaryType
      indoorSummerTemp
      indoorHumidity
      indoorWinterTemp
      indoorWinterHumidity
    }
  }
`)
